<template>
  <div :class="['lead-form form', editable ? 'editable': '']">
    <div v-if='allowCopyEdit && showCopy'>
      <h2 v-html='$t(content.title, "title", translationContext)'></h2>
      <div class="copy" v-html='$t(content.text, "text", translationContexts["copy"])'>
      </div>
    </div>
    <form action='#' autocomplete='off' @submit.prevent='false' class="form" v-if='!editable'>
      <div v-for='(field, i) in localFields'>
        <Field :tabindex='i+1' v-if='field.type !== "section"' :show-errors='initialized' :translation-context="`${translationContexts['fields']}.${i}`" ref='field' :key='field.name' :name='field.name' @validityChange='onValidityChange($event)' :label='field.label' :value='form[field.name]' @change='updateField(field.name, $event)' :field='field' :validate-with='field.validate'></Field>
        <div class='signup-section' v-if='field.type === "section"'>
          <h3 class='signup-section-title'>{{field.title}}</h3>
          <div class="signup-section-text" v-html='field.text'></div>
        </div>
      </div>

      <div class="field-component">
        <div class="input-wrapper">
          <label for="subscribed">
            <input tabindex="998" type='checkbox' name='subscribed' v-model='form.subscribed' :value='true'/>
            <span v-html='$t(privacyText, "form.privacyStatement", "signup")'></span>
          </label>
        </div>
        <div class='field-errors' v-if='!validity.subscribed && initialized'>
          <ul>
            <li><span class='small'>{{$t('Please agree to the terms and conditions', 'errors.requireAgreement', "signup")}}</span></li>
          </ul>
        </div>
      </div>
      <div class="actions" v-if='!editable'>
        <a role="button" tabindex="999" :style='buttonTheme' :disabled='!isValid' class='button next' v-on:keyup.enter.stop="signup" @click.prevent='signup'>{{$t(localButtonText, 'buttonText', translationContexts["signup"])}}</a>
      </div>
    </form>
  </div>
</template>
<script>
/* eslint-disable */
import Vue from 'vue'
import ContentEditable from './ContentEditable'
import Field from './Field'
import Button from './Button'
import TranslationMixin from '../lib/TranslationMixin'
export default {
  props: {
    fields: {type: Array, default: ()=>{[]}},
    translationContexts: {type: Object, default: ()=>{{}}},
    buttonText: {type: String, default: 'Sign up'},
    config: {type: Object, default: ()=>{{}}},
    editable: {type: Boolean, default: false},
    allowCopyEdit: {type: Boolean, default: true},
    showCopy: {type: Boolean, default: true}
  },
  inject: ['theme'],
  mixins: [TranslationMixin],
  components: {
    ContentEditable,
    Button,
    Field
  },
  computed: {
    buttonTheme () {
      let buttonTheme = {
        backgroundColor: this.config.buttonColor || this.theme.accent.backgroundColor,
        color: this.config.buttonTextColor || this.theme.accent.color,
        borderRadius: this.theme.borderRadius + 'px'
      }
      return buttonTheme
    },
    privacyText () {
      let html = this.content.privacyStatement
      if (!html || html === ''){
        return ''
      }
      let template = document.createElement('template')
      template.innerHTML = '<span>' + html + '<span>'
      let anchors = template.content.querySelectorAll('a')
      for (let anchor of anchors) {
        anchor.target = '_blank'
      }
      return template.content.firstChild.innerHTML
    },
    forceSignupField () {
      return {
        type: 'radio',
        label: 'Require sign up to view report?',
        options: [
          {label: 'Yes', value: true},
          {label: 'No', value: false}
        ]
      }
    },
    isValid () {
      let valid = true
      for (let prop in this.validity){
        if (this.validity[prop] !== true) {
          valid = false
        }
      }
      if (this.validity['subscribed'] === false) {
        valid = false
      }
      return valid
    }
  },
  data () {
    return {
      inputFieldTypes: ['text', 'email', 'radio'],
      initialized: false,
      localButtonText: '',
      localPrivacyText: '',
      localFields: [],
      validity: {
      },
      content: {},
      ready: false,
      complete: false,
      form: {
      },
      default_fields: [
        {autocomplete: 'first_name-au', label: 'First name', name: 'first_name', type: 'text', validate: {string:[2,100]}},
        {autocomplete: 'last_name-au', label: 'Last name', name: 'last_name', type: 'text', validate: {string:[2,100]}},
        {autocomplete: 'company-au', label: 'Company', name: 'company', type: 'text', validate: {string:[2,100]}},
        {label: 'Job title', name: 'job_title', type: 'text', validate: {string:[2,100]}},
        {autocomplete: 'email-au', label: 'Email', name: 'email', type: 'text', validate: {string:[2,100], regex: [/@/, "Must be a valid email address"]}},
        {autocomplete: 'tel_no-au', label: 'Contact number', name: 'tel_no', type: 'text', validate: {string:[2,50]}}
      ]
    }
  },
  methods: {
    onSignupButtonChange (text) {
      this.localButtonText = text
    },
    onValidityChange (event) {
      this.validity[event.name] = event.valid
    },
    signup () {
      if (this.complete) {
        return
      }
      this.initialized = true
      for (let field of this.$refs.field) {
        field.validateLocal()
      }
      if (!this.isValid) {
        return
      }
      const allowedUserFields = [
        'first_name',
        'last_name',
        'company',
        'job_title',
        'tel_no',
        'email',
        'subscribed'
      ]
      let userFields = {}
      let extraFields = {}
      for (let fieldName in this.form) {
        if (allowedUserFields.indexOf(fieldName) !== -1) {
          userFields[fieldName] = this.form[fieldName]
        } else {
          extraFields[fieldName] = this.form[fieldName]
        }
      }
      this.$emit('signup', {lead: userFields, extra: extraFields})
      this.$store.commit('signup', {lead: userFields, extra: extraFields})
      this.complete = true
    },
    close () {
      this.$emit('close')
    },
    updateSetting (setting, event) {
      this.content[setting] = event.value
    },
    updateField (index, event) {
      this.form[index] = event.value
    }
  },
  created () {
    this.content = this.config
    this.localButtonText = this.buttonText
    this.localFields = this.fields && !_.isUndefined(this.fields) && this.fields.length > 0 ? this.fields : this.default_fields
    this.localFields = this.localFields.filter(field => !field.disabled)
    let validationFields = {}
    let formFields = {}
    for (let field of this.localFields) {
      validationFields[field.name] = field.type === 'section' ? true : false
      if (field.type === 'select' && field.skipChoose === true) {
        Vue.set(this.form, field.name, field.options[0].value)
      } else if (field.type === 'checkbox') {
        Vue.set(this.form, field.name, false)
      } else {
        Vue.set(this.form, field.name, '')
      }
    }
    validationFields.subscribed = false
    Vue.set(this.form, 'subscribed', false)
    this.validity = validationFields
  },
  watch: {
    localButtonText: _.debounce(function(buttonText){
      this.$emit('change', buttonText)
    }),
    form: {
      deep: true,
      handler: function(newValue) {
        this.validity.subscribed = this.form.subscribed
      }
    }
  }
}
</script>
<style lang='scss'>
  .simple-form .lead-form .arrow-left {
    display: none;
  }
</style>
<style lang='scss' scoped>

  .form {
    
    label[for='subscribed']  {
      /deep/ span div {
        display: inline !important;
      }
    }
    /deep/ .cta.button {
      display: inline-block;
      width: auto;
    }
    /deep/ h2 {
      margin-bottom: 0.5rem;
    }
    .copy {
      margin-bottom: 1rem;
    }

    .signup-section {
      text-align: left;
      .signup-section-title {
        margin-bottom: 0.8rem;
      }
      .signup-section-text {

      }
    }

  }
</style>